export default {
  type: 'bold',
  tagName: 'bold'
}
